module.exports = __webpack_public_path__ + "static/media/image1.a667a365.png";